"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2023, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const LoadingPage_1 = __importDefault(require("chaire-lib-frontend/lib/components/pages/LoadingPage"));
const ValidationOnePageSummary_1 = __importDefault(require("./ValidationOnePageSummary"));
const surveyHelperNew = __importStar(require("evolution-common/lib/utils/helpers"));
const SurveyAdmin_1 = require("../../../actions/SurveyAdmin");
const ValidationLinks_1 = __importDefault(require("./ValidationLinks"));
const AdminErrorBoundary_1 = __importDefault(require("../hoc/AdminErrorBoundary"));
const InterviewSummary = (props) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const interview = (0, react_redux_1.useSelector)((state) => state.survey.interview);
    // extended: false runs only standard audit checks (fast, suitable for frequent refreshes during review)
    const refreshInterview = (0, react_1.useCallback)(() => {
        dispatch((0, SurveyAdmin_1.startFetchCorrectedInterviewAndAudits)(interview.uuid, false));
    }, [dispatch, interview.uuid]);
    // extended: true runs additional audit checks that may fetch external data or perform complex calculations (slower, use sparingly)
    const refreshInterviewWithExtended = (0, react_1.useCallback)(() => {
        dispatch((0, SurveyAdmin_1.startFetchCorrectedInterviewAndAudits)(interview.uuid, true));
    }, [dispatch, interview.uuid]);
    const resetInterview = (0, react_1.useCallback)(() => {
        dispatch((0, SurveyAdmin_1.startResetCorrectedInterview)(interview.uuid));
    }, [dispatch, interview.uuid]);
    const updateValuesByPath = (0, react_1.useCallback)((valuesByPath) => {
        dispatch((0, SurveyAdmin_1.startUpdateSurveyCorrectedInterview)({ sectionShortname: 'validationOnePager', valuesByPath }, () => {
            /* nothing to do */
        }));
    }, [dispatch]);
    if (!interview) {
        surveyHelperNew.devLog('%c rendering empty survey', 'background: rgba(0,0,0,0.1);');
        return (react_1.default.createElement("div", { className: "admin-widget-container" },
            react_1.default.createElement(LoadingPage_1.default, null)));
    }
    return (react_1.default.createElement("div", { className: "admin-widget-container" },
        react_1.default.createElement("div", { className: "survey validation" },
            react_1.default.createElement("div", { className: "admin__stats-container" },
                react_1.default.createElement(ValidationLinks_1.default, { handleInterviewSummaryChange: props.handleInterviewSummaryChange, updateValuesByPath: updateValuesByPath, interviewIsQuestionable: interview.is_questionable || false, interviewIsComplete: interview.is_completed, interviewUuid: interview.uuid, prevInterviewUuid: props.prevInterviewUuid, nextInterviewUuid: props.nextInterviewUuid, refreshInterview: refreshInterview, refreshInterviewWithExtended: refreshInterviewWithExtended, resetInterview: resetInterview, interview: interview })),
            react_1.default.createElement(AdminErrorBoundary_1.default, null,
                react_1.default.createElement(ValidationOnePageSummary_1.default, { key: interview.uuid })))));
};
exports.default = InterviewSummary;
//# sourceMappingURL=InterviewSummary.js.map